import { StorageService } from '../services';
import { constants } from '../constants';
import { HttpInterceptorFn } from '@angular/common/http';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const access_token = StorageService.getItem(constants.LM_AUTH)?.access_token;
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${access_token}`,
    },
    withCredentials: true,
  });

  return next(authReq);
};
